$(document).ready(function () {

  
 
    setInterval(function () {
      $(".product-form__item.cusPrdt-QuantitySec input#Quantity").attr(
        "readonly",
        "readonly"
      );
      $(".cusCartQuantity.cart__qty input").attr("readonly", "readonly");
    }, 100);
    $("body").on("click", "p.duplicate", function (event) {
      $("div#id01").show();
      var trget = $(this).attr("trget");
      $("div#id01").attr("trget", trget);
    });
  
    $("#id01").on("click", ".deletebtn", function (event) {
      var trget = $("div#id01").attr("trget");
      console.log("p." + trget + ".cart__remove.cusCartRemoveBtn");
      $("p." + trget + ".cart__remove.cusCartRemoveBtn a")[0].click();
      $("div#id01").fadeOut();
      setTimeout(function () {
        window.location.href = "/cart";
      }, 500);
    });
    $(window).scroll(function () {
      if ($(this).scrollTop() > 100) {
        $("body").addClass("scroll-add");
      } else {
        $("body").removeClass("scroll-add");
      }
    });
  
    /************* Home page *******/
    if ($(window).width() < 421) {
      $(".HomeProduct-slider").slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
      });
    } else if ($(window).width() < 750) {
      $(".HomeProduct-slider").slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
      });
    } else if ($(window).width() < 911) {
      $(".HomeProduct-slider").slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
      });
    } else {
      $(".HomeProduct-slider").slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
      });
    }
  
    if ($(window).width() < 530) {
      $(".cusHm-InfoTextWithImg").slick({
        autoplay: true,
        infinite: true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
      });
    } else if ($(window).width() < 750) {
      $(".cusHm-InfoTextWithImg").slick({
        autoplay: true,
        infinite: true,
        dots: true,
        slidesToShow: 2,
        slidesToScroll: 1,
      });
    }
  
    /************* Home page end*******/
  
    /************* product page *******/
  
    $(".prptyUploadFleRmve").click(function (e) {
      e.preventDefault();
      $(".custmUploadFl input").val("");
    });


              $(".OnChangeShowPrice").css("display", "none");
         $(".DefaultShowPrice").css("display", "inline-block ");
    $("body").on("change", "select.single-option-selector:eq(0)", function () {

    console.log("first  select box");
      $(
        '<option value="Choose an option" selected="selected">Choose an option</option>'
      ).prependTo(".single-option-selector:eq(1)");
      $(
        '<option value="Choose an option" selected="selected">Choose an option</option>'
      ).prependTo(".single-option-selector:eq(2)");
      $(this).css("color", "#000");
      $("select.single-option-selector:eq(1)").css("color", "#999");
      $("select.single-option-selector:eq(2)").css("color", "#999");
      setTimeout(function () {
        var selectBxOptn1 = $("select.single-option-selector:eq(1)").val();
        console.log("option 1 " + selectBxOptn1);
        var selectBxOptn2 = $("select.single-option-selector:eq(2)").val();
        console.log("count 2 " + selectBxOptn2);
  
        if (
          selectBxOptn1 == "Choose an option" ||
          selectBxOptn2 == "Choose an option"
        ) {
 
          console.log('choose');
          $(".cus_AddtoCartBtn").attr("disabled", "disabled");
          $(".cusProductCheckout").addClass("ProductCheckoutBtn-disable");
          $(".DefaultShowPrice").css("display", "inline-block ");
          $(".OnChangeShowPrice").css("display", "none");
          $(".PrdtOptionMsg").css("display", "block");
          $(".quote-btn").css("display", "none");
          $(".PrdtQuantitySecMain").addClass("DisableQuantityBtn");
          $(".PrptCheckboxInput").attr("disabled", "disabled");
        } else {
          if($('body').hasClass('opt_size_1')){
    
   $('.product-form__item--submit').removeClass('hide_btn')
}
          $(".cus_AddtoCartBtn").removeAttr("disabled");
          $(".cusProductCheckout").removeClass("ProductCheckoutBtn-disable");
          $(".DefaultShowPrice").css("display", "none");
          $(".OnChangeShowPrice").css("display", "inline-block");
          $(".PrdtOptionMsg").css("display", "none");
          $(".quote-btn").css("display", "inline-block");
          $(".PrdtQuantitySecMain").removeClass("DisableQuantityBtn");
          $(".PrptCheckboxInput").removeAttr("disabled");
        }
      }, 1000);
            
  // new adc btn
    function checkAddToCartButton() {
      const addToCartBtn = $('.cus_AddtoCartBtn');
  
      if (addToCartBtn.length === 0 || addToCartBtn.prop('disabled')) {
        
        $('.old_ppp').show();  
        $('.new_ppp').hide();   
      } else {
        
        $('.old_ppp').hide();   
        $('.new_ppp').show();  
      }
    }
  
    checkAddToCartButton();
  
    const observer = new MutationObserver(checkAddToCartButton);
  
    observer.observe(document.body, {
      childList: true, 
      subtree: true     
    });
  
    setInterval(checkAddToCartButton, 200); 
  // 
      
    });
  
    $("body").on("change", "select.single-option-selector:eq(1)", function () {
  console.log('2nd celected  select box')
      setTimeout(function(){
        
         
        
      },1000)
      $(
        '<option value="Choose an option" selected="selected">Choose an option</option>'
      ).prependTo(".single-option-selector:eq(2)");
      $(this).css("color", "#000");
      var scndselectbxVal = $(this).val();
      $("select.single-option-selector:eq(2)").css("color", "#999");
      setTimeout(function () {
        var selectBxOptn0 = $("select.single-option-selector:eq(0)").val();
        console.log("option 0 " + selectBxOptn0);
        var selectBxOptn2 = $("select.single-option-selector:eq(2)").val();
        console.log("count 2 " + selectBxOptn2);
  
        if (
          selectBxOptn0 == "Choose an option" ||
          selectBxOptn2 == "Choose an option" ||
          scndselectbxVal == "Choose an option"
        ) {
     
          $(".cus_AddtoCartBtn").attr("disabled", "disabled");
          $(".cusProductCheckout").addClass("ProductCheckoutBtn-disable");
          $(".DefaultShowPrice").css("display", "inline-block ");
          $(".OnChangeShowPrice").css("display", "none");
          $(".PrdtOptionMsg").css("display", "block");
          $(".quote-btn").css("display", "none");
          $(".PrdtQuantitySecMain").addClass("DisableQuantityBtn");
          $(".PrptCheckboxInput").attr("disabled", "disabled");
        } else {
          
          if($('body').hasClass('opt_size_2')){
             
   $('.product-form__item--submit').removeClass('hide_btn')
}
          $(".cus_AddtoCartBtn").removeAttr("disabled");
          $(".cusProductCheckout").removeClass("ProductCheckoutBtn-disable");
          $(".DefaultShowPrice").css("display", "none");
          $(".OnChangeShowPrice").css("display", "inline-block ");
          $(".quote-btn").css("display", "inline-block ");
          $(".PrdtOptionMsg").css("display", "none");
          $(".quote-btn").css("display", "inline-block");
          $(".PrdtQuantitySecMain").removeClass("DisableQuantityBtn");
          $(".PrptCheckboxInput").removeAttr("disabled");
        }
      }, 1000);
  
      
  // new adc btn
    function checkAddToCartButton() {
      const addToCartBtn = $('.cus_AddtoCartBtn');
  
      if (addToCartBtn.length === 0 || addToCartBtn.prop('disabled')) {
        
        $('.old_ppp').show();  
        $('.new_ppp').hide();   
      } else {
        
        $('.old_ppp').hide();   
        $('.new_ppp').show();  
      }
    }
  
    checkAddToCartButton();
  
    const observer = new MutationObserver(checkAddToCartButton);
  
    observer.observe(document.body, {
      childList: true, 
      subtree: true     
    });
  
    setInterval(checkAddToCartButton, 200); 
  // 
      
    });
  
    $("body").on("change", "select.single-option-selector:eq(2)", function () {
       console.log("Last 3 select box");
      $(this).css("color", "#000");
  
      var thirdselectbxVal = $(this).val();
      //console.log("third select box value "+ thirdselectbxVal);
      setTimeout(function () {
        var selectBxOptn0 = $("select.single-option-selector:eq(0)").val();
        console.log("option 0 " + selectBxOptn0);
        var selectBxOptn1 = $("select.single-option-selector:eq(1)").val();
        console.log("option 1 " + selectBxOptn1);
  
        if (
          selectBxOptn0 == "Choose an option" ||
          selectBxOptn1 == "Choose an option" ||
          thirdselectbxVal == "Choose an option"
        ) {
   
          $(".cus_AddtoCartBtn").attr("disabled", "disabled");
          $(".cusProductCheckout").addClass("ProductCheckoutBtn-disable");
          $(".DefaultShowPrice").css("display", "inline-block ");
          $(".OnChangeShowPrice").css("display", "none");
          $(".PrdtOptionMsg").css("display", "block");
          $(".quote-btn").css("display", "none");
          $(".PrdtQuantitySecMain").addClass("DisableQuantityBtn");
          $(".PrptCheckboxInput").attr("disabled", "disabled");
        } else {

          if($('body').hasClass('opt_size_3')){
             
   $('.product-form__item--submit').removeClass('hide_btn')
}
          $(".cus_AddtoCartBtn").removeAttr("disabled");
          $(".cusProductCheckout").removeClass("ProductCheckoutBtn-disable");
          $(".DefaultShowPrice").css("display", "none");
          $(".OnChangeShowPrice").css("display", "inline-block ");
          $(".quote-btn").css("display", "inline-block ");
          $(".PrdtOptionMsg").css("display", "none");
          $(".quote-btn").css("display", "inline-block");
          $(".PrdtQuantitySecMain").removeClass("DisableQuantityBtn");
          $(".PrptCheckboxInput").removeAttr("disabled");
        }
      }, 1000);
    });
  
    $(".ProductTabSec ul.tabs").each(function () {
      var active,
        content,
        links = $(this).find("a");
      active = links.first().addClass("active");
      content = $(active.attr("href"));
      links.not(":first").each(function () {
        $($(this).attr("href")).hide();
      });
      $(this)
        .find("a")
        .click(function (e) {
          active.removeClass("active");
          content.hide();
          active = $(this);
          content = $($(this).attr("href"));
          active.addClass("active");
          content.show();
          return false;
        });
    });
  
    /************* product page end*********************/
  
    /************cart page set cookie functionality*************/
    function setCookie(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toGMTString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
  
    function getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }
  
    $("body").on("click", ".CusEditPrdtWithVrnt a", function (e) {
      //e.preventDefault();
      var carteditOptnLnk = $(this).attr("href");
      var carteditOptnLnk_split = carteditOptnLnk.split("?variant=")[1];
      //alert(carteditOptnLnk_split);
  
      var setCookieTrue = getCookie("cookieTruedft");
      console.log("set cookie " + setCookieTrue);
      setCookie("cookieTruedft", "true", 365);
  
      if (setCookieTrue != "") {
        console.log("false");
      } else {
        console.log("true");
        /* variant id**/
        var variantid = getCookie("EditVariant");
        variantid = carteditOptnLnk_split;
        setCookie("EditVariant", variantid, 365);
        /* variant id end **/
  
        /***quantity ****/
        var cartQuntaty = $(this)
          .parent(".CusEditPrdtWithVrnt")
          .parent(".cartVrntPropertyInfo")
          .parent(".cart__product-information")
          .parent("td.CusPrdtInfoSec")
          .siblings(".cusCrtQuantitySec")
          .children(".cusCartQuantity")
          .children("input")
          .val();
        var CookieQuantity = getCookie("EditQuantity");
        CookieQuantity = cartQuntaty;
        setCookie("EditQuantity", CookieQuantity, 365);
        /***quantity end ****/
  
        $(this)
          .parent(".CusEditPrdtWithVrnt")
          .prev("ul.product-details")
          .children(".CuspropertyData")
          .each(function () {
            var cartpropertyVal = $(this).children(".itemPropertyData").text();
            //console.log("Property value "+ cartpropertyVal);
            var propertyText = $(this)
              .children(".itemPropertyData")
              .attr("data-hding");
            //console.log("abc "+ propertyText);
            if (propertyText.indexOf("Enter Custom Text") == 0) {
              //console.log("Enter Custom Text "+ propertyText);
              var textareaText = getCookie("EditStringText");
              //console.log("textareaText "+ textareaText);
              textareaText = cartpropertyVal;
              setCookie("EditStringText", textareaText, 365);
            } else if (propertyText.indexOf("Upload") == 0) {
              //console.log("Upload "+ propertyText);
              var uploadfile = getCookie("Edituploadfile");
              //console.log("Upload "+ uploadfile);
              uploadfile = cartpropertyVal;
              setCookie("Edituploadfile", uploadfile, 365);
            } else if (propertyText.indexOf("Request Artwork Proof") == 0) {
              //console.log("Request Artwork Proof "+ propertyText);
              var reqestProof = getCookie("EditreqestProof");
              //console.log("reqestProof "+ reqestProof);
              reqestProof = cartpropertyVal;
              setCookie("EditreqestProof", reqestProof, 365);
            } else if (
              propertyText.indexOf("Enter if any Info required to print") == 0
            ) {
              //console.log("Request Artwork Proof "+ propertyText);
              var BulderCatText = getCookie("EditBulderText");
              //console.log("reqestProof "+ reqestProof);
              BulderCatText = cartpropertyVal;
              setCookie("EditBulderText", BulderCatText, 365);
            }
          });
      }
    });
  
    var getCookieTrue = getCookie("cookieTruedft");
    if (getCookieTrue == "true") {
      console.log("if " + getCookieTrue);
      /* variant id*/
      var setCookieValue = getCookie("EditVariant");
      console.log("setCookieValue " + setCookieValue);
      if (setCookieValue != "") {
        //console.log("Welcome again " + setCookieValue);
        //alert("not null"+setCookieValue);
        $(".PrdtPg_AddToCrtBtn").css("display", "none");
        $(".PrdtPg_UpdateBtn").css("display", "block");
        //       $.ajax({
        //         type: 'POST',
        //         url: '/cart/change.js',
        //         data: 'quantity=0&id='+setCookieValue,
        //         dataType: 'json',
        //         success: function(cartdata){
        //         }
        //       });
      } else {
        //$(".PrdtPg_AddToCrtBtn").css("display","block");
        //$(".PrdtPg_UpdateBtn").css("display","none");
        //console.log("set cookie after click");
      }
      /* variant id*/
  
      /***quantity ****/
      var setCookieQuantity = getCookie("EditQuantity");
      console.log("setCookieQuantity " + setCookieQuantity);
      if (setCookieQuantity != "") {
        $(".changequantity").val(setCookieQuantity);
      }
      /***quantity end ****/
      /* property items*/
      var setCookieBulderText = getCookie("EditBulderText");
      //console.log("setCookieText "+ setCookieBulderText);
      if (setCookieBulderText != "") {
        $(".LineItmPrprty-Sec .bulderTextArea textarea").val(setCookieBulderText);
        //console.log("if textarea "+ setCookieBulderText);
      }
  
      var setCookieText = getCookie("EditStringText");
      //console.log("setCookieText "+ setCookieText);
      if (setCookieText != "") {
        $(".LineItmPrprty-Sec .custmTextArea textarea").val(setCookieText);
        //console.log("if textarea "+ setCookieText);
      }
  
      var setCookieUplod = getCookie("Edituploadfile");
      //console.log("setCookieUplod "+ setCookieUplod);
      if (setCookieUplod != "") {
        $(".setcookiemsg").css("display", "block");
        //console.log("if upload "+ setCookieUplod);
      } else {
        $(".setcookiemsg").css("display", "none");
        //console.log("else upload");
      }
  
      var setCookieProof = getCookie("EditreqestProof");
      //console.log("setCookieProof "+ setCookieProof);
  
      if (setCookieProof != "") {
        if (setCookieProof == "Yes") {
          $(".LineItmPrprty-Sec .CustmCkeckBox .PrptCheckboxInput").prop(
            "checked",
            true
          );
          //console.log("if setCookieProof "+ setCookieProof);
        } else if (setCookieProof == "No") {
          $(".LineItmPrprty-Sec .CustmCkeckBox .PrptCheckboxInput").prop(
            "checked",
            false
          );
          //console.log("if setCookieProof "+ setCookieProof);
        }
      }
      /* property items*/
    } else {
      console.log("else");
      $(".PrdtPg_AddToCrtBtn").css("display", "block");
      $(".PrdtPg_UpdateBtn").css("display", "none");
    }
  
    $(".PrdtPg_UpdateBtn").click(function (e) {
      //alert("test");
      e.preventDefault();
      console.log("adddd");
      $(".PrdtPg_AddToCrtBtn").css("display", "block");
      $(this).css("display", "none");
      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=0&id=" + setCookieValue,
        dataType: "json",
        success: function (cartdata) {
          $.removeCookie("cookieTruedft", { path: "/" });
          console.log(JSON.stringify(cartdata));
          $(".PrdtPg_AddToCrtBtn").trigger("click");
          //alert("test");
        },
      });
    });
  
    if (getCookieTrue == "") {
      console.log("if getCookieTrue " + getCookieTrue);
      $.removeCookie("EditVariant", { path: "/" });
      $.removeCookie("EditQuantity", { path: "/" });
      $.removeCookie("EditStringText", { path: "/" });
      $.removeCookie("Edituploadfile", { path: "/" });
      $.removeCookie("EditreqestProof", { path: "/" });
      $.removeCookie("EditBulderText", { path: "/" });
    } else {
      console.log("else getCookieTrue " + getCookieTrue);
    }
  
    var CurrentUrl = window.location.href;
    if (CurrentUrl.indexOf("products") > -1) {
    } else {
      //console.log("Current Url "+CurrentUrl);
      $.removeCookie("cookieTruedft", { path: "/" });
      $.removeCookie("EditVariant", { path: "/" });
      $.removeCookie("EditQuantity", { path: "/" });
      $.removeCookie("EditStringText", { path: "/" });
      $.removeCookie("Edituploadfile", { path: "/" });
      $.removeCookie("EditreqestProof", { path: "/" });
      $.removeCookie("EditBulderText", { path: "/" });
    }
    /************cart page set cookie functionality end*************/
  
    /************* collection page*********************/
    $(".cusCollSortBy").on("change", function () {
      var collectionSortopt = $(this).val();
      //console.log("collectionSortopt " + collectionSortopt);
      if (collectionSortopt == "best-selling") {
        //console.log("if match");
      } else {
        //console.log("not match");
        $(this).addClass("cusSrtSlctbxWidth");
      }
    });
    /************* collection page end*********************/
  
    /************* login page*********************/
    //$(".CusEyeIcn").prev("input").attr("type","password");
    $(".CusPasswrdEyeIcn img").click(function () {
      var loginATTRval = $(this)
        .parent(".CusPasswrdEyeIcn")
        .prev("input")
        .attr("type");
      //console.log("password attr value "+loginATTRval);
      if (loginATTRval == "password") {
        $(this).parent(".CusPasswrdEyeIcn").prev("input").attr("type", "text");
        $(this).attr(
          "src",
          "https://cdn.shopify.com/s/files/1/2666/0918/files/eye-icon-show.png"
        );
      } else {
        $(this)
          .parent(".CusPasswrdEyeIcn")
          .prev("input")
          .attr("type", "password");
        $(this).attr(
          "src",
          "https://cdn.shopify.com/s/files/1/2666/0918/files/eye-icon-hide.png"
        );
      }
    });
    /************* login page end****************/
  
    /*************collection page*********************/
    var CollectionUrl = window.location.href;
    if (CollectionUrl == "https://k2k-signs.myshopify.com/collections") {
      window.location.replace(
        "https://k2k-signs.myshopify.com/pages/safety-signs"
      );
    }
    if ($(window).width() < 750) {
      $(".CollectionSideBar-Sec h2").click(function () {
        $(this).next(".CollectionSideBar").toggleClass("CollectionSideBar-show");
      });
    } else {
    }
    /*************collection page end*********************/
  
    /*************site map page *********************/
    $(".sitemapper-list li").each(function () {
      var sitemapPrdtTtL = $(this).text();
      //console.log("site map product list "+sitemapPrdtTtL);
      if (sitemapPrdtTtL.indexOf("<br/>") > -1) {
        var stmpUpdtPrdtnm = sitemapPrdtTtL.replace(
          new RegExp("<br/>", "gi"),
          ""
        );
        $(this).children("a").text(stmpUpdtPrdtnm);
      } else {
        //nsole.log("else not contain br ");
      }
    });
  
    $(".sitemapper-view-more").click(function () {
      setTimeout(function () {
        $(".sitemapper-list li").each(function () {
          var CsitemapPrdtTtL = $(this).text();
          //console.log("site map product list "+sitemapPrdtTtL);
          if (CsitemapPrdtTtL.indexOf("<br/>") > -1) {
            var CstmpUpdtPrdtnm = CsitemapPrdtTtL.replace(
              new RegExp("<br/>", "gi"),
              ""
            );
            $(this).children("a").text(CstmpUpdtPrdtnm);
          } else {
            //console.log("else not contain br ");
          }
        });
      }, 500);
    });
  
    /*************site map page end*********************/
    $("select#SingleOptionSelector-2").change(function () {
      console.log("test123");
      setTimeout(function () {
        var grtvlue = $("select#SingleOptionSelector-2 option:selected").attr(
          "value"
        );
              var fileUploadSection = document.getElementById('file-upload-section');
                   if (grtvlue == "I Have Print Ready Artwork") {
                       console.log('I Have Print Ready Artwork done');
                    fileUploadSection.style.display = 'block';
                } else {
                    fileUploadSection.style.display = 'none';
                };
                   var fileUploadSectionNew = document.getElementById('file-upload-section-2');
   var text1 = document.getElementById('text_option_1');
         var text2 = document.getElementById('text_option_2');
                         if (grtvlue == "My Artwork Needs Proofing") {
                    text1.style.display = 'block';
                                             fileUploadSectionNew.style.display = 'block';
                } else {
                    text1.style.display = 'none';
                             fileUploadSectionNew.style.display = 'none';
                };
   var fileUploadSectionNew1 = document.getElementById('file-upload-section-3');
                               if (grtvlue == "Design it For Me (Expert Graphic Design)") {
                    text2.style.display = 'block';
                                  fileUploadSectionNew1.style.display = 'block';
                } else {
                    text2.style.display = 'none';
                                 fileUploadSectionNew1.style.display = 'none';
                };
        
        console.log("test" + grtvlue);
        if (
          grtvlue == "Reflective Class 2 Sticker" ||
          grtvlue == "Reflective Class 2 Sign" ||
          grtvlue == "Reflective Class 2 Stickers" ||
          grtvlue == "Reflective Class 2 Aluminum Sign" ||
          grtvlue == "Reflective Class 1 Aluminum Sign"
        ) {
          $("select#SingleOptionSelector-2").prev("label").find("span").remove();
          $("select#SingleOptionSelector-2")
            .prev("label")
            .append(
              '<span class="optclick" hit="opt2"><abbr title="Info about Reflective Class 2 ">ⓘ</abbr></span>'
            );
        } else if (
          grtvlue == "Reflective Class 1 Sticker" ||
          grtvlue == "Reflective Class 1 Sign" ||
          grtvlue == "Reflective Class 2 Stickers" ||
          grtvlue == "Reflective Class 2 Aluminum Sign" ||
          grtvlue == "Reflective Class 1 Aluminum Sign"
        ) {
          $("select#SingleOptionSelector-2").prev("label").find("span").remove();
          $("select#SingleOptionSelector-2")
            .prev("label")
            .append(
              '<span class="optclick" hit="opt3"><abbr title="Info about Reflective Class 1 ">ⓘ</abbr></span>'
            );
        } else {
          $("select#SingleOptionSelector-2").prev("label").find("span").remove();
        }
      }, 50);
    });
  });
  
  $(document).ready(function () {
    var count = 0;
    $("#lodingBtn2").click(function (e) {
      e.preventDefault();
      var pageurl = $(this).attr("href");
      console.log(pageurl + "first");
      $.ajax({
        type: "GET",
        url: pageurl,
        dataType: "html",
        success: function (data) {
          var nextpagehtml = $(data).find("#collectionThumbs2").html();
          var loadbtnurl = $(data).find("#lodingBtn2").attr("href");
          //console.log(loadbtnurl);
          $("#collectionThumbs2").append(
            "<span id='scroll-items" +
              count +
              "' class='CollectionPrdt-list grid__item grid__item--collection-template small--one-half medium-up--one-quarter' style='width: 0px;height: 0px;margin: 0px;padding: 0px;'><span>"
          );
          $("#collectionThumbs2").append(nextpagehtml);
          $("body, html").animate(
            { scrollTop: $("#scroll-items" + count).offset().top },
            1000
          );
          $("#lodingBtn2").attr("href", loadbtnurl);
          if ($(".cusldbtn2").attr("href") == "") {
            $(".custm_collloding2").addClass("loaddone");
          }
          count = count + 1;
        },
      });
    });
    $(document).on("click", ".optclick", function (event) {
      console.log("resr");
      if ($(window).width() < 767) {
        var hit = $(this).attr("hit");
        if (hit == "opt3") {
          $(".ProductTabSec ul.tabs li:nth-child(3) a")[0].click();
          $("html, body").animate(
            {
              scrollTop: $("#mobscroll").offset().top,
            },
            2000
          );
        } else {
          $(".ProductTabSec ul.tabs li:nth-child(3) a")[0].click();
          $("html, body").animate(
            {
              scrollTop: $("#scrolhere").offset().top,
            },
            2000
          );
        }
      } else {
        $(".ProductTabSec ul.tabs li:nth-child(3) a")[0].click();
        $("html, body").animate(
          {
            scrollTop: $("#scrolhere").offset().top,
          },
          2000
        );
      }
    });
  });
  
  $("#custom-text_2").change(function () {
    if (this.checked) {
      //   $(".cusProductCheckout").addClass('ProductCheckoutBtn-disable');
    } else {
      //  $(".cusProductCheckout").removeClass('ProductCheckoutBtn-disable');
    }
  });
  $(".optclick__size").on("click", function () {
    $(".ProductTabSec ul.tabs li:nth-child(4) a")[0].click();
    var off = 180;
    $("html, body").animate(
      {
        scrollTop: $(".ProductTabSec").offset().top - off,
      },
      1000
    );
  });
  
  // NEW TESTIMONIAL SLIDER SCRIPT
  
  $("#closePopup").click(function () {
      $(".overlay").hide();
    }); 
  
  // END
  
  
    $(document).ready(function () {
    // Click event for the link
    $('.site-footer__linklist-item a').on('click', function (e) {
      e.preventDefault(); // Prevent default link behavior
      const linkText = $(this).text().trim();
  
      // Check if the text matches
      if (linkText === 'Report Website Problem or Provide Feedback') {
        $('#overlay, #feedback-popup').fadeIn(); // Show the popup and overlay
      }
    });
  
    // Close popup and overlay
    $('#close-popup, #overlay').on('click', function () {
      $('#overlay, #feedback-popup').fadeOut(); // Hide the popup and overlay
    });
  });

  // $(document).ready(function () {
  //   const $secondSelect = $('#SingleOptionSelector-2');

  //   function updateOptions() {
  //     const selected1 = $('#SingleOptionSelector-1').val();

  //     // Always show default option first
  //     $secondSelect.find('option').hide(); // Hide all
  //     $secondSelect.find('option[value="Choose an option"]').show().prop('selected', true); // Show default

  //     if (selected1.includes('Pack of 5')) {
  //       $secondSelect.find('option[value="YES(Pack of 5 Metal Grass Spikes)"]').show();
  //     } else if (selected1.includes('Pack of 10')) {
  //       $secondSelect.find('option[value="YES(Pack of 10 Metal Grass Spikes)"]').show();
  //     }
  //   }

  //   // Run on change
  //   $('#SingleOptionSelector-1').on('change', updateOptions);

  //   // Run once on load
  //   updateOptions();
  // });




